import { Dispatch } from 'redux';

import { AppServices } from 'ha/services/getAppServices';
import { buildParams } from '@ha/search-query';
import { UrlResolver } from 'ha/helpers/UrlResolver';
import { changeLocation } from 'ha/modules/URLLocationHandler';
import { send as sendAlert } from 'ha/modules/Alertbar/actions';
import { reportError } from 'ha/helpers/bugsnag/reportError';
import { AlertType, AlertDismissAfter } from 'ha/modules/Alertbar/types';

import { normalizeDate } from '@ha/date';
import { FormValues } from '../components/SearchBar';
import { ErrorMessages } from '../constants';

const submitSearch =
  ({
    formValues,
    lang,
    urlResolver,
  }: {
    formValues: FormValues;
    lang: string;
    urlResolver: UrlResolver;
  }) =>
  (dispatch: Dispatch<any>, __: () => void, { apiV2 }: AppServices) =>
    apiV2
      .searchCity({ query: formValues.place, languages: [lang] })
      .then(({ data: city }) => {
        const { cityName, countryName } = city[lang];
        const nextUrl = `${urlResolver.getSearchUrl(cityName, countryName)}`;

        const { dateRange } = formValues;
        const params = buildParams({
          startDate: normalizeDate(dateRange.startDate) || null,
          endDate: normalizeDate(dateRange.endDate) || null,
        });
        const nextLocation = `${nextUrl}${params}`;

        dispatch(changeLocation(nextLocation));
      })
      .catch(error => {
        if (error.status === 404) {
          dispatch(
            sendAlert({
              text: ErrorMessages.SEARCH_NOT_FOUND,
              kind: AlertType.Warning,
              dismissAfter: AlertDismissAfter.Default,
            }),
          );
        } else {
          reportError('Search listings onSubmitFail', { metaData: { error } });
        }
      });

export { submitSearch };
